<template>
  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>

    <div style="display: grid; grid-template-columns: 4fr 1fr; gap: 1rem; align-items: start;">
      <div class="form-content">
        <div class="form-content-title">
          <div class="form-content-title-block form-title">
            <div class="form-title-block form-title-principal">
              <span>Warehouse</span>
            </div>

            <div
              class="form-title-block"
              v-if="$store.state.user.attributes.permissions_keys.includes(8)"
            >
              <button @click="openModal('modal-wr')" class="btn btn-primary">
                <i class="fas fa-plus"></i>
                Nuevo paquete
              </button>
            </div>
          </div>
          <div class="">
            <div class="">
              <label>Buscar por:</label>
    
              <div class="d-flex justify-content-between col-6 px-0" style="gap: .75rem;">
                <select
                  id="select-search"
                  class="form-control"
                >
                  <option selected>Nombre de orden</option>
                  <option>Número de orden</option>
                  <option>Número de WR</option>
                </select>
    
                <input
                  id="search-bar"
                  type="search"
                  class="form-control"
                  placeholder="Buscar..."
                />

                <button class="btn btn-primary">
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <div class="table-paquete">
          <data-table
            :columns="columns"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            @sort="sortBy"
            v-if="is_loading == false"
          >
            <section class="u-table p-4">
              <div class="u-row-wr u-row--header">
                <h4 class="u-row__title">Producto</h4>
                <h4 class="u-row__title">Warehouse</h4>
                <h4 class="u-row__title">Acciones</h4>
              </div>
              <div class="u-row-wr" v-for="data in warehouseorder" :key="data">
                <div>
                  <!-- Boton de nuevo paquete -->
                  <button v-if="!isOrder" @click="openModal('modal-orden')" class="btn-paquete" type="button">
                    <i class="fas fa-plus"></i>
                    <span>Asociar orden</span>
                  </button>
                  <!-- Card de producto -->
                  <article v-else class="card-product">
                    <a href="#" target="_blank">
                      <img src="https://images.unsplash.com/photo-1542291026-7eec264c27ff?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8c2hvZXMlMjBuaWtlfGVufDB8fDB8&ixlib=rb-1.2.1&auto=format&fit=crop&w=600&q=60" class="card-product__img">
                    </a>
                    <div class="card-product__text">
                      <h3 class="card-product__title">
                        <span>Nike shoes</span>
                        <a href="#">
                          <i class="fas fa-link"></i>
                        </a>
                      </h3>
                      <div class="card-product__info">
                        <p class="">
                          <span class="">Nombres:</span>
                          Jesus Gallardo
                        </p>
                        <p class="">
                          <span class="">Código del cliente:</span>
                          #123456789
                        </p>
                        <p class="">
                          <span class="">Código de Tracking:</span>
                          #12345
                        </p>
                        <p class="">
                          <span class="">Viaje desde:</span>
                          Miami, Estados Unidos
                        </p>
                        <p class="">
                          <span class="">Viaje a:</span>
                          Lima, Perú
                        </p>
                        <p class="">
                          <span class="">Número de orden:</span>
                          #12345
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
                <div style="max-width: 30vw;">
                  <!-- Boton de nuevo paquete -->
                  <button v-if="!isWr" class="btn-paquete" type="button" @click="openModal('modal-wr')">
                    <i class="fas fa-plus"></i>
                    <span>Nuevo paquete</span>
                  </button>
                  <!-- Cards de warehouse -->
                  <template v-else>
                    <vue-glide :perView="2">
                      <vue-glide-slide>
                        <article class="card-product">
                          <div class="card-product__text">
                            <h3 class="card-product__title">
                              <span>#123456</span>
                              <a href="#">
                                <i class="fas fa-link"></i>
                              </a>
                            </h3>
                            <div class="card-product__info">
                              <p class="">
                                <span class="">Remitente:</span>
                                Jesus Gallardo
                              </p>
                              <p class="">
                                <span class="">Consignatario:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Carrier:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Código de Tracking:</span>
                                #12345
                              </p>
                              <p class="">
                                <span class="">Peso:</span>
                                100 <b>kg</b>
                              </p>
                              <p class="">
                                <span class="">Comentario:</span>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
                              </p>
                              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                                <i class="fas fa-link mr-2"></i>
                                Ver fotos
                              </a>
                            </div>
                          </div>
                        </article>
                      </vue-glide-slide>
                      <vue-glide-slide>
                        <article class="card-product">
                          <div class="card-product__text">
                            <h3 class="card-product__title">
                              <span>#123456</span>
                              <a href="#">
                                <i class="fas fa-link"></i>
                              </a>
                            </h3>
                            <div class="card-product__info">
                              <p class="">
                                <span class="">Remitente:</span>
                                Jesus Gallardo
                              </p>
                              <p class="">
                                <span class="">Consignatario:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Carrier:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Código de Tracking:</span>
                                #12345
                              </p>
                              <p class="">
                                <span class="">Peso:</span>
                                100 <b>kg</b>
                              </p>
                              <p class="">
                                <span class="">Comentario:</span>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
                              </p>
                              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                                <i class="fas fa-link mr-2"></i>
                                Ver fotos
                              </a>
                            </div>
                          </div>
                        </article>
                      </vue-glide-slide>
                      <vue-glide-slide>
                        <article class="card-product">
                          <div class="card-product__text">
                            <h3 class="card-product__title">
                              <span>#123456</span>
                              <a href="#">
                                <i class="fas fa-link"></i>
                              </a>
                            </h3>
                            <div class="card-product__info">
                              <p class="">
                                <span class="">Remitente:</span>
                                Jesus Gallardo
                              </p>
                              <p class="">
                                <span class="">Consignatario:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Carrier:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Código de Tracking:</span>
                                #12345
                              </p>
                              <p class="">
                                <span class="">Peso:</span>
                                100 <b>kg</b>
                              </p>
                              <p class="">
                                <span class="">Comentario:</span>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
                              </p>
                              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                                <i class="fas fa-link mr-2"></i>
                                Ver fotos
                              </a>
                            </div>
                          </div>
                        </article>
                      </vue-glide-slide>
                      <vue-glide-slide>
                        <article class="card-product">
                          <div class="card-product__text">
                            <h3 class="card-product__title">
                              <span>#123456</span>
                              <a href="#">
                                <i class="fas fa-link"></i>
                              </a>
                            </h3>
                            <div class="card-product__info">
                              <p class="">
                                <span class="">Remitente:</span>
                                Jesus Gallardo
                              </p>
                              <p class="">
                                <span class="">Consignatario:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Carrier:</span>
                                Lorem, ipsum dolor.
                              </p>
                              <p class="">
                                <span class="">Código de Tracking:</span>
                                #12345
                              </p>
                              <p class="">
                                <span class="">Peso:</span>
                                100 <b>kg</b>
                              </p>
                              <p class="">
                                <span class="">Comentario:</span>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
                              </p>
                              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                                <i class="fas fa-link mr-2"></i>
                                Ver fotos
                              </a>
                            </div>
                          </div>
                        </article>
                      </vue-glide-slide>

                      <template slot="control">
                        <button data-glide-dir="<" class="slider__btn slider__btn--prev">
                          <i class="fas fa-arrow-left"></i>
                        </button>
                        <button data-glide-dir=">" class="slider__btn slider__btn--next">
                          <i class="fas fa-arrow-right"></i>
                        </button>
                      </template>
                    </vue-glide>
                  </template>
                </div>
                <div>
                  <button
                    @click.prevent="openModal('modal-wr', data.id)"
                    class="btn btn-primary mb-3 d-block mx-auto"
                    :disabled="data.attributes.warehouse_flag == 1"
                  >
                    Registrar ingreso
                  </button>
                  <button
                    @click.prevent="limitchangePaquete(data.id)"
                    class="btn btn-primary d-block mx-auto"
                  >
                    {{
                      data.attributes.warehouse_flag == 0
                        ? "Items incompletos"
                        : "Items completos"
                    }}
                  </button>
                </div>
              </div>
            </section>
          </data-table>
        </div>
      </div>
      <div  class="wr-slider-vertical">
        <article class="card-product">
          <div class="card-product__text">
            <h3 class="card-product__title">
              <span>#123456</span>
              <a href="#">
                <i class="fas fa-link"></i>
              </a>
            </h3>
            <div class="card-product__info">
              <p class="">
                <span class="">Remitente:</span>
                Jesus Gallardo
              </p>
              <p class="">
                <span class="">Consignatario:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Carrier:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Código de Tracking:</span>
                #12345
              </p>
              <p class="">
                <span class="">Peso:</span>
                100 <b>kg</b>
              </p>
              <p class="">
                <span class="">Comentario:</span>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
              </p>
              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                <i class="fas fa-link mr-2"></i>
                Ver fotos
              </a>
            </div>
          </div>
        </article>
        <article class="card-product">
          <div class="card-product__text">
            <h3 class="card-product__title">
              <span>#123456</span>
              <a href="#">
                <i class="fas fa-link"></i>
              </a>
            </h3>
            <div class="card-product__info">
              <p class="">
                <span class="">Remitente:</span>
                Jesus Gallardo
              </p>
              <p class="">
                <span class="">Consignatario:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Carrier:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Código de Tracking:</span>
                #12345
              </p>
              <p class="">
                <span class="">Peso:</span>
                100 <b>kg</b>
              </p>
              <p class="">
                <span class="">Comentario:</span>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
              </p>
              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                <i class="fas fa-link mr-2"></i>
                Ver fotos
              </a>
            </div>
          </div>
        </article>
        <article class="card-product">
          <div class="card-product__text">
            <h3 class="card-product__title">
              <span>#123456</span>
              <a href="#">
                <i class="fas fa-link"></i>
              </a>
            </h3>
            <div class="card-product__info">
              <p class="">
                <span class="">Remitente:</span>
                Jesus Gallardo
              </p>
              <p class="">
                <span class="">Consignatario:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Carrier:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Código de Tracking:</span>
                #12345
              </p>
              <p class="">
                <span class="">Peso:</span>
                100 <b>kg</b>
              </p>
              <p class="">
                <span class="">Comentario:</span>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
              </p>
              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                <i class="fas fa-link mr-2"></i>
                Ver fotos
              </a>
            </div>
          </div>
        </article>
        <article class="card-product">
          <div class="card-product__text">
            <h3 class="card-product__title">
              <span>#123456</span>
              <a href="#">
                <i class="fas fa-link"></i>
              </a>
            </h3>
            <div class="card-product__info">
              <p class="">
                <span class="">Remitente:</span>
                Jesus Gallardo
              </p>
              <p class="">
                <span class="">Consignatario:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Carrier:</span>
                Lorem, ipsum dolor.
              </p>
              <p class="">
                <span class="">Código de Tracking:</span>
                #12345
              </p>
              <p class="">
                <span class="">Peso:</span>
                100 <b>kg</b>
              </p>
              <p class="">
                <span class="">Comentario:</span>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Consequuntur odit necessitatibus aliquam?
              </p>
              <a href="#" style="color: #1EA9E4; font-weight: 600;" @click.prevent="openModal('modal-fotos')">
                <i class="fas fa-link mr-2"></i>
                Ver fotos
              </a>
            </div>
          </div>
        </article>
      </div>
    </div>

    <pagination
      :pagination="pagination"
      @changePagination="getPurchaseOrders"
      v-if="is_loading == false"
    ></pagination>
    <!-- Modal Warehouse -->
    <dialog id="modal-wr">
      <article class="u-modal">
        <form @submit.prevent="createPaquete" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Datos del paquete</span>
            <span style="cursor: pointer" @click="closeModal('modal-wr')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <div class="form-group">
            <label>Consignatario</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.consignee"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label>Remitente</label>
            <div class="input-group">
              <input
                type="text"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Carrier </label>
              <div class="input-group">
                <input
                  type="text"
                  v-model="formCreate.carrier"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Tracking </label>
              <div class="input-group">
                <input
                  type="text"
                  v-model="formCreate.tracking"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Peso</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="formCreate.weight"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Unidad de peso:</label>
              <div class="input-group">
                <select class="form-control" v-model="formCreate.unidad" required>
                  <option selected="selected" :value="12">Kg</option>
                  <option selected="selected" :value="2">Lb</option>
                  <option selected="selected" :value="22">Oz</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Comentario</label>
            <div class="input-group">
              <textarea
                v-model="formCreate.comment"
                type="text"
                name=""
                class="form-control input"
                rows="6"
                required
              ></textarea>
            </div>
          </div>
          <div class="form-group">
            <label>Fotos del paquete</label>
            <div class="input-group">
              <input
                type="file"
                @change="handleFileInput"
                multiple
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <button type="submit" class="btn btn-primary mx-auto d-block mt-4">
            Registrar ingreso
          </button>
        </form>
      </article>
    </dialog>
    <dialog id="modal-orden">
      <article class="u-modal">
        <form class="u-modal-content" style="max-width: 95vw; max-height: 80vh;">
          <div class="form-block-text d-flex justify-content-between">
            <span>Asociar orden</span>
            <span style="cursor: pointer" @click="closeModal('modal-orden')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <div class="form-content">
            <div class="form-content-title">
              <div class="form-content-title-block form-title">
                <div class="form-title-block form-title-principal">
                  <span>Órdenes de compra</span>
                </div>
              </div>
      
              <div class="form-content-title-block filter-container">
                <div class="filter-block filter-block-various">
                  <label>Buscar por:</label>
      
                  <div class="filter-block-content">
                    <select
                      id="select-search"
                      class="form-control"
                      v-model="tableData.filterBy"
                      @change="cleanInput()"
                    >
                      <option value="all">Todos</option>
                      <option
                        :value="option.name"
                        v-for="option in filterColumns"
                        :key="option.id"
                      >
                        {{ option.label }}
                      </option>
                    </select>
      
                    <input
                      id="search-bar"
                      type="search"
                      class="form-control"
                      v-model="tableData.filterValue"
                      placeholder="Buscar..."
                      @keyup="getPurchaseOrdersByPage()"
                    />
                  </div>
                </div>
      
                <div class="filter-block filter-block-alone">
                  <label>Estado:</label>
      
                  <div class="multiselect form-control" id="checkboxes2">
                    <div class="selectBox" @click="showCheckboxes">
                      <select class="kt-form__label">
                        <option>Seleccionar</option>
                      </select>
      
                      <div class="overSelect"></div>
                    </div>
      
                    <div id="checkboxes">
                      <label class="check-filter" for="one">
                        <input
                          type="checkbox"
                          class="checkbox-style box-check"
                          v-model="tableData.statusFlag.todos"
                          @change="getPurchaseOrdersByPage()"
                        />Todos
                      </label>
                      <label class="check-filter" for="two">
                        <input
                          type="checkbox"
                          class="checkbox-style box-check"
                          v-model="tableData.statusFlag.activos"
                          @change="getPurchaseOrdersByPage()"
                        />Activos
                      </label>
                      <label class="check-filter" for="three">
                        <input
                          type="checkbox"
                          class="checkbox-style box-check"
                          v-model="tableData.statusFlag.cancelados"
                          @change="getPurchaseOrdersByPage()"
                        />Cancelados
                      </label>
                    </div>
                  </div>
                </div>
                <div class="filter-bloc filter-block-alone">
                  <label>Tipo de orden:</label>
                  <select
                    class="form-control"
                    v-model="tableData.store"
                    @change="getPurchaseOrdersByPage()"
                  >
                    <option value="all" selected>Todo</option>
                    <option
                      value="sendi"
                      data-content="<span class='badge badge-info'>Ofertas de Grabr</span>"
                    >
                      Sendi
                    </option>
                    <option
                      value="enviosusa"
                      data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
                    >
                      Envios Usa
                    </option>
                  </select>
                </div>
                <!-- <div class="filter-bloc filter-block-alone">
                  <label>Tipo de orden:</label>
                  <select
                    class="form-control"
                    v-model="tableData.order_type"
                    @change="getPurchaseOrdersByPage()"
                  >
                    <option :value="5" selected>Todo</option>
                    <option
                      :value="1"
                      data-content="<span class='badge badge-info'>Ofertas de Grabr</span>"
                    >
                      Grabr
                    </option>
                    <option
                      :value="2"
                      data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
                    >
                      Direct
                    </option>
                    <option
                      :value="3"
                      data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
                    >
                      Linio
                    </option>
                    <option
                      :value="4"
                      data-content="<span class='badge badge-warning'>Ofertas no Grabr</span>"
                    >
                      Meli
                    </option>
                  </select>
                </div> -->
              </div>
      
              <div class="filter-bloc" v-if="tableData.order_type === 4">
                <div class="wrap">
                  <form action="" class="formulario">
                    <div class="radio">
                      <span v-if="this.valorRadioButton == true">
                        <input type="radio" id="inicio" />
                        <label for="inicio">Todo</label>
                      </span>
      
                      <span v-else-if="this.valorRadioButton == false">
                        <input
                          type="radio"
                          id="todo"
                          :value="null"
                          v-model="tableData.store"
                          @change="getPurchaseOrdersByPage()"
                        />
                        <label for="todo">Todo</label>
                      </span>
      
                      <input
                        type="radio"
                        id="electro"
                        :value="'electro'"
                        v-model="tableData.store"
                        @change="getPurchaseOrdersByPage()"
                        @click="cambiarEstado"
                      />
                      <label for="electro">Electro</label>
      
                      <input
                        type="radio"
                        id="fashion"
                        :value="'fashion'"
                        v-model="tableData.store"
                        @change="getPurchaseOrdersByPage()"
                        @click="cambiarEstado"
                      />
                      <label for="fashion">Fashion</label>
      
                      <input
                        type="radio"
                        id="kids"
                        :value="'kids'"
                        v-model="tableData.store"
                        @change="getPurchaseOrdersByPage()"
                        @click="cambiarEstado"
                      />
                      <label for="kids">Kids</label>
      
                      <input
                        type="radio"
                        id="home"
                        :value="'home'"
                        v-model="tableData.store"
                        @change="getPurchaseOrdersByPage()"
                        @click="cambiarEstado"
                      />
                      <label for="home">Home</label>
                      <input
                        type="radio"
                        id="pets"
                        :value="'pets'"
                        v-model="tableData.store"
                        @change="getPurchaseOrdersByPage()"
                        @click="cambiarEstado"
                      />
                      <label for="pets">Pets</label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
      
            <!--circle-spin v-if="is_loading"></circle-spin>-->
      
            <div class="table-orders">
              <data-table
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
                v-if="is_loading == false"
              >
                <tbody v-if="purchaseOrders != null && purchaseOrders.length > 0">
                  <router-link
                    :to="{
                      name: 'show-purchase-order',
                      params: { id: purchaseOrder.id, orderData: purchaseOrder },
                    }"
                    v-for="purchaseOrder in diasRestantes"
                    :key="purchaseOrder.id"
                  >
                    <tr>
                      <td>
                        <div class="image-table">
                          <img
                            v-if="
                              purchaseOrder.attributes.product_image_url == null &&
                              purchaseOrder.attributes.is_from_meli_flag
                            "
                            :src="'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'"
                            width="180px"
                            height="260px"
                          />
                          <img
                            v-else-if="
                              purchaseOrder.attributes.product_image_url == null &&
                              purchaseOrder.attributes.is_from_linio_flag
                            "
                            src="/static/img/linio-logo.png"
                            width="180px"
                            height="260px"
                          />
                          <img
                            v-else-if="purchaseOrder.attributes.product_image_url"
                            :src="purchaseOrder.attributes.product_image_url"
                            width="180px"
                            height="260px"
                          />
                          <img
                            v-else
                            :src="'https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png'"
                            width="180px"
                            height="260px"
                          />
                        </div>
      
                        <div class="description-title">
                          <span class="description-title-principal">{{
                            purchaseOrder.attributes.product_info
                          }}</span>
      
                          <div>
                            <span class="code-order system-code"
                              >SB #{{ purchaseOrder.id }}
                            </span>
      
                            <span
                              class="code-order grabr-code"
                              v-if="purchaseOrder.attributes.is_from_linio_flag"
                            >
                              #{{
                                purchaseOrder.attributes.linioOrder.attributes.linio_order_id
                              }}</span
                            >
      
                            <span
                              class="code-order grabr-code"
                              v-else-if="purchaseOrder.attributes.is_from_meli_flag"
                            >
                              #{{
                                purchaseOrder.attributes.meliOrder.attributes.meli_order_id
                              }}</span
                            >
                            <br />
                            <span
                              :class="
                                purchaseOrder.attributes.status == 10
                                  ? 'bg-danger'
                                  : 'bg-success'
                              "
                              class="badge badge-primary"
                            >
                              {{
                                purchaseOrder.attributes.status == 10 ? "Cancelada" : "Activa"
                              }}
                            </span>
                            <span
                              class="badge badge-primary bg-success"
                              v-if="purchaseOrder.attributes.type === 2"
                              >{{ purchaseOrder.attributes.store }}</span
                            >
                            <span
                              class="badge badge-primary bg-primary"
                              v-if="purchaseOrder.attributes.reference_link"
                              >{{ getStore(purchaseOrder.attributes.reference_link) }}</span
                            >
                            <span class="badge badge-primary bg-secondary"
                              >WR -{{ purchaseOrder.attributes.warehouse_admin }}</span
                            >
                          </div>
      
                          <div
                            v-if="purchaseOrder.attributes.is_from_grabr_flag"
                            class="grabr-des"
                          >
                            <span class="badge badge-primary badge-grabr">Grabr</span>
      
                            <span
                              class="code-order grabr-code"
                              @click="
                                toGrabrDetail(
                                  purchaseOrder.attributes.grabrOrder.attributes
                                    .grabr_order_number
                                )
                              "
                              >{{
                                purchaseOrder.attributes.grabrOrder.attributes
                                  .grabr_order_number
                              }}</span
                            >
                          </div>
      
                          <div
                            v-else-if="purchaseOrder.attributes.is_from_linio_flag"
                            class="grabr-des"
                          >
                            <span class="badge badge-primary badge-linio">Linio</span>
      
                            <!-- <span class="code-order grabr-code" v-b-popover.hover.top="'Codigo del Partner' " @click="toGrabrDetail(purchaseOrder.attributes.grabrOrder.attributes.grabr_order_number)" >{{purchaseOrder.attributes.grabrOrder.attributes.grabr_order_number}}</span> -->
                          </div>
      
                          <div
                            v-else-if="purchaseOrder.attributes.is_from_meli_flag"
                            class="grabr-des"
                          >
                            <span class="badge badge-primary badge-meli">Mercado libre</span>
                            <span
                              class="badge badge-primary badge-store bg-primary"
                              v-if="
                                purchaseOrder.attributes.meliOrder.attributes.store ===
                                'electro'
                              "
                              >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                            </span>
                            <span
                              class="badge badge-primary badge-store magenta"
                              v-if="
                                purchaseOrder.attributes.meliOrder.attributes.store === 'kids'
                              "
                              >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                            </span>
                            <span
                              class="badge badge-primary badge-store brown"
                              v-if="
                                purchaseOrder.attributes.meliOrder.attributes.store ===
                                'fashion'
                              "
                              >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                            </span>
                            <span
                              class="badge badge-primary badge-store bg-success"
                              v-if="
                                purchaseOrder.attributes.meliOrder.attributes.store === 'home'
                              "
                              >{{ purchaseOrder.attributes.meliOrder.attributes.store }}
                            </span>
                          </div>
                        </div>
                      </td>
      
                      <td>
                        <span class="">{{ purchaseOrder.attributes.product_specimens }}</span>
                      </td>
      
                      <td
                        v-if="
                          purchaseOrder.attributes.origin != undefined &&
                          purchaseOrder.attributes.destination != undefined
                        "
                      >
                        <div class="ruta-order-container">
                          <div class="ruta-order-block ruta-order-image">
                            <img src="/static/img/ruta.svg" alt="" />
                          </div>
      
                          <div class="ruta-order-block">
                            <div class="ruta-order-content">
                              <span>{{ purchaseOrder.attributes.origin.attributes.name }}</span>
                            </div>
      
                            <div class="ruta-order-content">
                              <span>{{ purchaseOrder.attributes.destination_address }}</span>
                            </div>
                          </div>
                        </div>
                      </td>
      
                      <td v-else>
                        <span class="ruta-order">No se ha definido</span>
                      </td>
      
                      <td>
                        <div class="order-tag-container">
                          <span>
                            <img src="/static/img/icon-pago-status.png" width="20" alt="" />
                            <span v-if="purchaseOrder.attributes.payed === 1">PENDIENTE</span>
                            <span v-else-if="purchaseOrder.attributes.payed === 2"
                              >EN PROCESO</span
                            >
                            <span v-else-if="purchaseOrder.attributes.payed === 3"
                              >CONFIRMADO</span
                            >
                            <span v-else-if="purchaseOrder.attributes.payed === 10"
                              >RECHAZADO"</span
                            >
                            <span v-else-if="purchaseOrder.attributes.payed === 11"
                              >RECLAMADO</span
                            >
                            <span v-else-if="purchaseOrder.attributes.payed === 12"
                              >RETORNADO</span
                            >
                          </span>
      
                          <span>
                            <ul>
                              <li>
                                <span>
                                  <span
                                    v-if="purchaseOrder.attributes.payment_method_flag === 5"
                                  >
                                    <img
                                      v-if="purchaseOrder.attributes.payment_code === null"
                                      src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                      width="30"
                                      alt=""
                                    />
                                    <img
                                      v-else-if="
                                        purchaseOrder.attributes.payment_code !== null &&
                                        purchaseOrder.attributes.payed !== 3
                                      "
                                      src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                      width="30"
                                      alt=""
                                    />
                                    <img
                                      v-else-if="purchaseOrder.attributes.payed === 3"
                                      src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                      width="30"
                                      alt=""
                                    />
                                  </span>
                                  <span
                                    v-if="purchaseOrder.attributes.payment_method_flag === 2"
                                  >
                                    <img
                                      v-if="
                                        purchaseOrder.attributes.paypalPayment.attributes
                                          .paypal_order_id === null
                                      "
                                      src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                      width="30"
                                      alt=""
                                    />
                                    <img
                                      v-else-if="
                                        purchaseOrder.attributes.paypalPayment.attributes
                                          .paypal_order_id !== null &&
                                        purchaseOrder.attributes.payed !== 3
                                      "
                                      src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                      width="30"
                                      alt=""
                                    />
                                    <img
                                      v-else-if="purchaseOrder.attributes.payed === 3"
                                      src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                      width="30"
                                      alt=""
                                    />
                                  </span>
                                  <span
                                    v-if="purchaseOrder.attributes.payment_method_flag === 3"
                                  >
                                    <img
                                      v-if="
                                        purchaseOrder.attributes.mercadopagoPayment.attributes
                                          .payment_id === null
                                      "
                                      src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                      width="30"
                                      alt=""
                                    />
                                    <img
                                      v-else-if="
                                        purchaseOrder.attributes.mercadopagoPayment.attributes
                                          .payment_id !== null &&
                                        purchaseOrder.attributes.payed !== 3
                                      "
                                      src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                      width="30"
                                      alt=""
                                    />
                                    <img
                                      v-else-if="purchaseOrder.attributes.payed === 3"
                                      src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                      width="30"
                                      alt=""
                                    />
                                  </span>
                                  <span
                                    v-if="purchaseOrder.attributes.payment_method_flag === 4"
                                  >
                                    <img
                                      v-if="
                                        purchaseOrder.attributes.atm_payment.mp_payment_id ===
                                        null
                                      "
                                      src="/static/img/statuPagoIcon/PagoCodigo-1.png"
                                      width="30"
                                      alt="" />
                                    <img
                                      v-else-if="
                                        purchaseOrder.attributes.atm_payment.mp_payment_id !==
                                          null && purchaseOrder.attributes.payed !== 3
                                      "
                                      src="/static/img/statuPagoIcon/PagoCodigo-2.png"
                                      width="30"
                                      alt="" />
                                    <img
                                      v-else-if="purchaseOrder.attributes.payed === 3"
                                      src="/static/img/statuPagoIcon/PagoCodigo-3.png"
                                      width="30"
                                      alt=""
                                  /></span>
                                  <span
                                    v-if="purchaseOrder.attributes.payment_method_flag === 6"
                                    >Pago con saldo</span
                                  >
                                  - Código</span
                                >
                              </li>
      
                              <li>
                                <img
                                  v-if="purchaseOrder.attributes.voucher_link === null"
                                  src="/static/img/statuPagoIcon/PagoVaucher-1.png"
                                  width="30"
                                  alt=""
                                />
                                <img
                                  v-else-if="
                                    purchaseOrder.attributes.voucher_link !== null &&
                                    purchaseOrder.attributes.payed !== 3
                                  "
                                  src="/static/img/statuPagoIcon/PagoVaucher-3.png"
                                  width="30"
                                  alt=""
                                />
                                <img
                                  v-else-if="purchaseOrder.attributes.payed === 3"
                                  src="/static/img/statuPagoIcon/PagoVaucher-2.png"
                                  width="30"
                                  alt=""
                                />
                                - Voucher
                              </li>
                            </ul>
                          </span>
      
                          <span>
                            <img src="/static/img/icon-tracking-statu.png" width="20" alt="" />
                            <span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 1
                              "
                            >
                              EN REVISIÓN</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 2
                              "
                            >
                              COMPRADO</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 3
                              "
                            >
                              PREPARANDO PARA ENVIAR</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 4
                              "
                            >
                              LISTO PARA ENVIAR</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 5
                              "
                            >
                              ENVIADO</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 6
                              "
                            >
                              LISTO PARA ENTREGAR</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 7
                              "
                            >
                              ENTREGADO</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 8
                              "
                            >
                              SINIESTRADO</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 9
                              "
                            >
                              EN PROCESO DE DEVOLUCIÓN</span
                            ><span
                              v-if="
                                purchaseOrder.attributes.order_tracking_details[
                                  purchaseOrder.attributes.order_tracking_details.length - 1
                                ].attributes.status === 10
                              "
                            >
                              RETORNADO AL PROVEEDOR</span
                            >
                          </span>
      
                          <!-- <span
                            class="order-tag order-init"
                            v-if="
                              purchaseOrder.attributes.status >= 1 &&
                              purchaseOrder.attributes.status <= 3
                            "
                            >Inicializando</span
                          >
      
                          <span
                            class="order-tag order-process"
                            v-else-if="
                              purchaseOrder.attributes.status > 3 &&
                              purchaseOrder.attributes.status < 10
                            "
                            >En proceso</span
                          >
      
                          <span
                            class="order-tag order-cancel"
                            v-else-if="purchaseOrder.attributes.status == 10"
                            >Cancelado</span
                          >
      
                          <span
                            class="order-tag order-message"
                            v-if="
                              purchaseOrder.attributes.status < 10 &&
                              purchaseOrder.attributes.status != 4
                            "
                            >{{ statusArray[purchaseOrder.attributes.status] }}</span
                          >
      
                          <span
                            class="order-tag order-message"
                            v-if="
                              purchaseOrder.attributes.status < 10 &&
                              purchaseOrder.attributes.status == 4
                            "
                            >{{
                              purchaseOrder.attributes.origin != undefined
                                ? statusArray[purchaseOrder.attributes.status] +
                                  " (" +
                                  purchaseOrder.attributes.origin.attributes.name +
                                  ")"
                                : "Ciudad origen no definida"
                            }}</span
                          >
      
                          <span class="" v-else>{{
                            cancelledReasonFlagArray[
                              purchaseOrder.attributes.cancelled_reason_flag
                            ]
                          }}</span> -->
                        </div>
                      </td>
      
                      <!-- <td>
                        <span class="">{{
                          purchaseOrder.attributes.order_create_date | spanishDate
                        }}</span>
                      </td> -->
      
                      <td>
                        <span class="">
                          <img
                            v-if="purchaseOrder.attributes.vouchers_usa.length !== 0"
                            src="/static/img/statuFactura/factura-1.svg"
                            width="50"
                            alt=""
                          />
                          <img
                            v-else
                            src="/static/img/statuFactura/factura-2.svg"
                            width="50"
                            alt=""
                          />
                        </span>
                      </td>
      
                      <td>
                        <span class="">{{ purchaseOrder.attributes.order_create_date }}</span>
                      </td>
      
                      <td
                        v-if="purchaseOrder.attributes.hasOwnProperty('promised_delivery_date')"
                      >
                        <span>{{
                          purchaseOrder.attributes.promised_delivery_date | spanishDate
                        }}</span>
                        <div class="daysLeft">
                          <span
                            class="badge badge-primary bg-success"
                            v-if="purchaseOrder.resultado > 15"
                            >{{ purchaseOrder.resultado }} días</span
                          >
                          <span
                            class="badge badge-primary bg-warning"
                            v-if="purchaseOrder.resultado > 10 && purchaseOrder.resultado <= 15"
                          >
                            {{ purchaseOrder.resultado }} días
                          </span>
                          <span
                            class="badge badge-primary bg-danger"
                            v-if="purchaseOrder.resultado <= 10"
                          >
                            <span v-if="Math.sign(purchaseOrder.resultado) === 1"
                              >{{ purchaseOrder.resultado }} días
                            </span>
                            <span v-if="Math.sign(purchaseOrder.resultado) === -1">
                              Retraso de
                              {{ Math.abs(purchaseOrder.resultado) }} dias</span
                            >
                            <span v-if="Math.sign(purchaseOrder.resultado) === 0">
                              Retraso</span
                            >
                          </span>
                        </div>
                      </td>
                      <td v-else>
                        <span class="">No definido</span>
                      </td>
                    </tr>
                  </router-link>
                </tbody>
      
                <tbody v-else>
                  <div class="no-results">
                    <h1>No se encontraron resultados</h1>
                  </div>
                </tbody>
              </data-table>
            </div>
          </div>
        </form>
      </article>
    </dialog>
    <dialog id="modal-fotos">
      <article class="u-modal">
        <form class="u-modal-content" style="max-width: 70vw; width: 70vw;">
          <div class="form-block-text d-flex justify-content-between">
            <span>Fotos del producto</span>
            <span style="cursor: pointer" @click="closeModal('modal-fotos')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <div class="gallery" style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem;">
            <img class="product-image" src="http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg" alt="">
            <img class="product-image" src="http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg" alt="">
            <img class="product-image" src="http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg" alt="">
            <img class="product-image" src="http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg" alt="">
            <img class="product-image" src="http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg" alt="">
            <img class="product-image" src="http://c.files.bbci.co.uk/B9FF/production/_117751674_satan-shoes1.jpg" alt="">
          </div>
        </form>
      </article>
    </dialog>
  </div>
</template>
<style>
  .table tr {
              border: none;
  }
  .u-table {
  }

  .u-row-wr {
    display: grid;
    align-items: start;
    grid-template-columns: 2fr 3fr 1fr;
    gap: 1.5rem;
    margin-bottom: 2.5rem;
  }

  .u-row--header {
    padding-bottom: .75rem;
    border-bottom: 1px solid #ccc;
  }

  .u-row__title {
    font-size: 14px;
    font-weight: 700;
    opacity: .65;
  }


  .card-product {
    display: flex;
    align-items: flex-start;
    gap: 1.25rem;
    padding: 1.25rem 1rem;
    border-radius: 8px;
    box-shadow: 0 0 8px rgba(0, 0, 0, .25);
    color: #4F5665;
    margin: .25rem;
    background-color: #fff;
  }

  .card-product__img {
    display: block;
    border-radius: 50%;
    object-fit: cover;
    width: 3rem;
    height: 3rem;
    box-shadow: 0 0 8px rgba(0, 0, 0, .5);
  }

  .card-product__text {
    width: 100%;
  }

  .card-product__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 600;
    font-size: 1rem;
    margin-bottom: 1.25rem;
    gap: 1rem;
  }

  .card-product__info {
    display: grid;
    grid-template-columns: 1fr;
    gap: .75rem;
  }

  .card-product__info p {
    font-size: 14px;
    margin: 0;
  }

  .card-product__info p span:nth-of-type(1){
    display: block;
    font-weight: 600;
    margin-bottom: .25rem;
    background-color: transparent;
  }

  .btn-paquete {
    cursor: pointer;
    display: grid;
    gap: 1rem;
    border: 3px solid rgba(30, 169, 228, .25);
    background-color: rgba(30, 169, 228, .15);
    border-radius: 12px;
    padding: 1.5rem 2rem;
    width: max-content;
    margin: 0 auto;
    text-align: center;
    color: #1990c4;
    font-size: 18px;
    font-weight: 600;
  }

  .slider__btn {
    position: absolute;
    top: calc(50% - 24px);
    cursor: pointer;
    font-size: 24px;
    border: none;
    background-color: transparent;
  }

  .slider__btn--prev {
    left: -1.5rem;
  }

  .slider__btn--next {
    right: -1.5rem;
  }

  .product-image {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .wr-slider-vertical {
    max-height: 88vh;
    display: grid; 
    gap: .75rem; 
    overflow-y: auto; 
    position: sticky; 
    top: 4rem;
  }
</style>
<script>
import { Glide, GlideSlide } from 'vue-glide-js'

import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import DataTable from "./DataTable.vue";
import Pagination from "./Pagination.vue";
import axios from "axios";
export default {
  components: { DataTable, Pagination, breadcrumb,
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide
  },
  data() {
    // eslint-disable-next-line no-unused-vars
    let statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado",
    };
    // eslint-disable-next-line no-unused-vars
    let statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado",
    };
    // eslint-disable-next-line no-unused-vars
    let cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking",
    };
    let sortOrders = {};
    let columns = [
      { label: "Producto", name: "product", visible: false },
      { label: "Consignatario", name: "consignatario", visible: false },
      { label: "Acciones", name: "acciones", visible: false },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      isOrder: true,
      isWr: true,
      //almacena todos los paquetes
      warehouseorder: null,
      //Formulario para crear un paquete
      formCreate: {
        purchase_order_id: null,
        consignee: null,
        carrier: null,
        tracking: null,
        comment: null,
        unidad: 12,
        weight: null,
        images: [],
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns,
      statusGroupArray,
      statusArray,
      cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true,
        }, // 0: Inicializando, 1: En proceso, 2: Cancelado, 3: Finalizado
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null, // no hay ningun valor por el cual filtrar
        order_type: 5, // órdenes de Grabr y no Grabr
        store: "all",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      grabr: {
        id: "1",
      },
      is_loading: true,
      nameSection: "Warehouse",
      listRoutes: [{ nameRoute: "Warehouse", titleRoute: "Warehouse" }],
    };
  },
  created() {
    this.getPurchaseOrders();
  },
  methods: {
    limitchangePaquete(idOrder) {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/warehouse/changeWarehouseStatus/" + idOrder;
      axios
        .get(url)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al cambiar el estado");
          this.is_loading = false;
        });
    },
    //dev marco -> guardar imagees del apquete//
    handleFileInput(event) {
      const files = event.target.files;
      const images = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.match("image.*")) {
          continue;
        }
        const reader = new FileReader();

        reader.onload = (function (file) {
          return function (event) {
            images.push(event.target.result);
          };
        })(file);
        reader.readAsDataURL(file);
        this.formCreate.images = images;
      }
    },

    //dev marco ->create paquete//
    createPaquete() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/warehouse/save-package";
      axios
        .post(url, {
          purchase_order_id: this.formCreate.purchase_order_id,
          consignee: this.formCreate.consignee,
          carrier: this.formCreate.carrier,
          tracking: this.formCreate.tracking,
          comment: this.formCreate.comment,
          weight_unit_id: this.formCreate.unidad,
          weight: this.formCreate.weight,
          images: this.formCreate.images,
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al crear el paquete");
          this.is_loading = false;
        });
    },
    getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado() {
      this.valorRadioButton = false;
    },

    toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      let linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getPurchaseOrders(page, url = "", fromPagination = false) {
      // 1: Ver todas las órdenes de compra, 2: Ver todas las órdenes de compra por operador, 3: Ver todas las órdenes de compra por cliente
      console.log("Cargando todas las PurchasOrders");
      this.is_loading = true;
      this.tableData.page = page;
      this.tableData.draw++;
      url = process.env.API_URL + "/api/purchaseOrder/list-orders-all";
      this.tableData.status = this.statusComputed;
      axios
        .get(url, { params: fromPagination ? {} : this.tableData })
        .then((response) => {
          let data = response.data;
          console.log(data);
          if (this.tableData.draw === data.meta.draw || fromPagination) {
            console.log("there are sync or if from pagination");
            this.warehouseorder = data.data;
            this.configPagination(data);
            this.is_loading = false;
          } else {
            console.log("out of sync");
            this.is_loading = false;
          }
        })
        .catch((errors) => {
          console.log(errors);
          console.log(errors.response);
          console.log("error");
          // alert('No se obtuvieron resultados')
          this.warehouseorder = null;
          this.is_loading = false;
          return;
        });
    },
    getPurchaseOrdersByPage(page = 1) {
      // 1: Ver todas las órdenes de compra,
      // 2: Ver todas las órdenes de compra por operador
      // 3: Ver todas las órdenes de compra por cliente
      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      let permissions = this.$store.state.user.attributes.permissions_keys;
      let url = "";
      if (permissions.includes(1)) {
        url = process.env.API_URL + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-client";
      } else {
        // alert('El usuario no tiene permisos para ver órdenes de compra')
        return;
      }
      this.tableData.status = this.statusComputed;

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          let data = response.data;

          if (this.tableData.draw === data.meta.draw) {
            console.log("RESPONSE:");

            console.log("there are sync");
            console.log("Table data : ");
            console.log(this.tableData);
            console.log(data);

            console.log("=======================");

            this.purchaseOrders = data.data;
            this.configPagination(data);
            this.is_loading = false;
            console.log("FIN RESPONSE");
          } else {
            console.log("ERROR:");

            console.log("out of sync");

            console.log(this.tableData);
            this.is_loading = false;
            console.log("FIN ERROR");
          }
        })
        .catch((errors) => {
          console.log(errors);
          console.log(errors.response);
          console.log("error");
          // alert('No se obtuvieron resultados')
          this.purchaseOrders = null;
          this.is_loading = false;
          return;
        });
    },
    cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir,
        this.sortOrders[key]
      );
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir
      );
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
    hideModal() {
      this.$refs.formmodal.hide();
    },
    // toDetailView(data) {
    //   console.log(data)
    //   this.$router.push({
    //     name: 'show-purchase-order',
    //     params: { id: data.id, orderData: data }
    //   })
    // },
    openModal(id, idorder) {
      const modal = document.getElementById(id);
      this.formCreate.purchase_order_id = idorder ? idorder : null;
      modal.showModal();
    },
    closeModal(id) {
      const modal = document.getElementById(id);
      modal.close();
    },
    prevSlide() {
      this.currentSlide === 1 
        ? this.currentSlide = this.maxSlide
        : this.currentSlide = this.currentSlide - 1 
    },
    nextSlide() {
      this.currentSlide === this.maxSlide 
        ? this.currentSlide = 1
        : this.currentSlide = this.currentSlide + 1 
    }
  },
  computed: {
    diasRestantes() {
      let fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach((data) => {
        let fechaEntrega = data.attributes.promised_delivery_date;
        let fecha = new Date();
        let fechaini = new Date(fechaEntrega);
        let diff = fechaini.getTime() - fecha.getTime();
        let diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns() {
      // let activeFilterColumns = [
      //   "product_info",
      //   "destination",
      //   "order_code",
      //   "tracking_number",
      //   "grabr_code",
      //   "client_name",
      //   "client_dni",
      //   "client_grabr_id",
      //   "id",
      // ];

      let activeFilterColumns = [
        "product_info",
        "referent link",
        "order_code",
        "client_grabr_id",
        "destination",
        "tracking_number",
      ];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
    statusComputed() {
      console.log("statuscomputed");
      return JSON.stringify([
        this.tableData.statusFlag.todos,
        this.tableData.statusFlag.activos,
        this.tableData.statusFlag.cancelados,
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// WarehouseTable2.vue?47e39908